import React from "react";

import * as S from "./styles";
import { IProps } from "./types";

const LabelStatus: React.FC<IProps> = ({
  label,
  status,
}: IProps) => {
  return (
    <>
      <S.Wrapper
        status={status}
      />
      <span>{label}</span>
    </>
  )
};

export { LabelStatus }